import { useWizard } from 'react-use-wizard';
function ColorStep({ items = [], value, handleChangeColor, onSubmitProduct }) {
   const { previousStep, nextStep } = useWizard();

   const selectColorType = type => {
      handleChangeColor(type);
   };

   const handleNextStep = () => {
      nextStep();
      onSubmitProduct();
   }

   return (
      <div className="step">
         <div className="step__container">
            <div className="step__content">
               <div className="step__hint">Оберіть колір</div>
               <div className="step__colors">
                  {items.map(item => (
                     <div
                        key={item.id}
                        className={`step__color ${value && value.id === item.id ? 'selected' : ''}`}
                        style={{ backgroundColor: item.hex }}
                        onClick={() => selectColorType(item)}
                     >
                        <p>{item.name}</p>
                     </div>
                  ))}
               </div>
            </div>
         </div>
         <div className="step__navigation">
            <button className="step__navigation-item" onClick={() => previousStep()}>
               назад
            </button>
            <button className="step__navigation-item" disabled={!value || !value.id} onClick={handleNextStep}>
               далі
            </button>
         </div>
      </div>
   );
}

export default ColorStep;
